import { render, staticRenderFns } from "./risk.vue?vue&type=template&id=3963c21c&scoped=true&"
import script from "./risk.vue?vue&type=script&lang=js&"
export * from "./risk.vue?vue&type=script&lang=js&"
import style0 from "./risk.vue?vue&type=style&index=0&id=3963c21c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3963c21c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3963c21c')) {
      api.createRecord('3963c21c', component.options)
    } else {
      api.reload('3963c21c', component.options)
    }
    module.hot.accept("./risk.vue?vue&type=template&id=3963c21c&scoped=true&", function () {
      api.rerender('3963c21c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/print/components/risk.vue"
export default component.exports